module.exports = __webpack_public_path__ + "img/publication-1.2963d568.svg";